import { ActionContext } from 'vuex'
import Vue from 'vue'
import apiSejour from '@/api/sejour'
import apiUser from '@/api/user'
import apiCommande from '@/api/commande'
import apiMailTemplate from '@/api/mailTemplate'
import apiMailSkin from '@/api/mailSkin'
import apiPanStatus from '@/api/panStatus'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import store, { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { IAdministrationState } from './state'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloSejour } from '@/models/alo/AloSejour'
import { AloCommande } from '@/models/alo/AloCommande'
import { AloUser } from '@/models/alo/AloUser'
import { AloMailSkin } from '@/models/alo/AloMailSkin'
import { AloMailTemplate } from '@/models/alo/AloMailTemplate'
import { AloPanStatus } from '@/models/alo/AloPanStatus'
import { AlsUser } from '@/models/als/AlsUser'
import { AlsSejour } from '@/models/als/AlsSejour'
import { AlsCommande } from '@/models/als/AlsCommande'

export class AdministrationAction {
    
   
    //////////////////////////////////////////////////////////////////
    // SEJOUR
    /////////////////////////////////////////////////////////////////

    public [types.ADM_SEJOUR_REQUEST](context: ActionContext<IAdministrationState, IRootState>,sjrFilter:AlsSejour|null) {
        const action = sjrFilter?
                payloadAction(context,types.ADM_SEJOUR_REQUEST,types.ADM_SEJOUR_SUCCESS,types.ADM_SEJOUR_ERROR,apiSejour.getFilterSejour,sjrFilter,sjrFilter.commit)                
               :emptyAction(context,types.ADM_SEJOUR_REQUEST,types.ADM_SEJOUR_SUCCESS,types.ADM_SEJOUR_ERROR,apiSejour.getAllSejour)   

            if(sjrFilter) action.then((sejours)=> {
                if(context.state.lastSejourQuery) {
                    if(sejours.filter(s => new Date(s.sjrDatadd) > context.state.lastSejourQuery!).length > 0) {
                        var audio = new Audio('https://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3')
                        Vue.nextTick(() => { audio.play() })
                    }
                }
                context.commit(types.ADM_SEJOUR_UPDATE_LAST_QUERY_DATE)                                        
            })
        return action
    }

    public [types.ADM_SEJOUR_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_SEJOUR_REQUEST,context.state.sejourList)    
    }

    public [types.ADM_SEJOUR_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_SEJOUR_DETAIL_REQUEST,types.ADM_SEJOUR_DETAIL_SUCCESS,types.ADM_SEJOUR_DETAIL_ERROR,apiSejour.getSejour,id)
    }

    public [types.ADM_SEJOUR_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.sejourDic[id];
        return actionEnsure(context,types.ADM_SEJOUR_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_SEJOUR_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloSejour) {
        return payloadAction(context,types.ADM_SEJOUR_SAVE_REQUEST,types.ADM_SEJOUR_SAVE_SUCCESS,types.ADM_SEJOUR_SAVE_ERROR,apiSejour.saveSejour,data).then((sejour)=>{
            if(context.getters?.user?.id == sejour.usrId) context.dispatch(actionsTypes.AUTH_USER_REQUEST)
        })    

    }

    public [types.ADM_SEJOUR_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {        
        return payloadAction(context,types.ADM_SEJOUR_DELETE_REQUEST,types.ADM_SEJOUR_DELETE_SUCCESS,types.ADM_SEJOUR_DELETE_ERROR,apiSejour.deleteSejour,id).then((sejour)=> {            
            if(context.getters?.user?.id == sejour.usrId) context.dispatch(actionsTypes.AUTH_USER_REQUEST)
        })        
    }

    public [types.ADM_SEJOUR_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_SEJOUR_RESET_STATUS)
            resolve()
        })
    }     
    
    
    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////

    public [types.ADM_USER_REQUEST](context: ActionContext<IAdministrationState, IRootState>,usrFilter:AlsUser|null) {
        return usrFilter?
                payloadAction(context,types.ADM_USER_REQUEST,types.ADM_USER_SUCCESS,types.ADM_USER_ERROR,apiUser.getFilterUser,usrFilter,usrFilter.commit)
               :emptyAction(context,types.ADM_USER_REQUEST,types.ADM_USER_SUCCESS,types.ADM_USER_ERROR,apiUser.getAllUser)    
    }

    public [types.ADM_USER_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_USER_REQUEST,context.state.userList)    
    }

    public [types.ADM_USER_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_USER_DETAIL_REQUEST,types.ADM_USER_DETAIL_SUCCESS,types.ADM_USER_DETAIL_ERROR,apiUser.getUser,id)
    }

    public [types.ADM_USER_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.userDic[id];
        return actionEnsure(context,types.ADM_USER_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_USER_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloUser) {
        return payloadAction(context,types.ADM_USER_SAVE_REQUEST,types.ADM_USER_SAVE_SUCCESS,types.ADM_USER_SAVE_ERROR,apiUser.saveUser,data)    
    }

    public [types.ADM_USER_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_USER_DELETE_REQUEST,types.ADM_USER_DELETE_SUCCESS,types.ADM_USER_DELETE_ERROR,apiUser.deleteUser,id)    
    }

    public [types.ADM_USER_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_USER_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////

    public [types.ADM_COMMANDE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,cmdFilter:AlsCommande) {
        const action = cmdFilter?
                payloadAction(context,types.ADM_COMMANDE_REQUEST,types.ADM_COMMANDE_SUCCESS,types.ADM_COMMANDE_ERROR,apiCommande.getFilterCommande,cmdFilter,cmdFilter.commit)                
               :emptyAction(context,types.ADM_COMMANDE_REQUEST,types.ADM_COMMANDE_SUCCESS,types.ADM_COMMANDE_ERROR,apiCommande.getAllCommande)        

               if(cmdFilter) action.then((commandes)=> {
                if(!cmdFilter.histo) {
                    if(context.state.lastCommandeQuery) {
                        if(commandes.filter(d => new Date(d.panDatadd) > context.state.lastCommandeQuery!).length > 0) {
                            var audio = new Audio('https://soundbible.com/mp3/Censor%20Beep-SoundBible.com-250233510.mp3')
                            Vue.nextTick(() => { audio.play() })
                        }
                    }
                    context.commit(types.ADM_COMMANDE_UPDATE_LAST_QUERY_DATE)                                        
                }
            })
        return action
    }

    public [types.ADM_COMMANDE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_COMMANDE_REQUEST,context.state.commandeList)    
    }

    public [types.ADM_COMMANDE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_COMMANDE_DETAIL_REQUEST,types.ADM_COMMANDE_DETAIL_SUCCESS,types.ADM_COMMANDE_DETAIL_ERROR,apiCommande.getCommande,id)
    }

    public [types.ADM_COMMANDE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.commandeDic[id];
        return actionEnsure(context,types.ADM_COMMANDE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_COMMANDE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloCommande) {
        return payloadAction(context,types.ADM_COMMANDE_SAVE_REQUEST,types.ADM_COMMANDE_SAVE_SUCCESS,types.ADM_COMMANDE_SAVE_ERROR,apiCommande.saveCommande,data)    
    }

    public [types.ADM_COMMANDE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_COMMANDE_DELETE_REQUEST,types.ADM_COMMANDE_DELETE_SUCCESS,types.ADM_COMMANDE_DELETE_ERROR,apiCommande.deleteCommande,id)    
    }

    public [types.ADM_COMMANDE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_COMMANDE_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////

    public [types.ADM_MAIL_TEMPLATE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_MAIL_TEMPLATE_REQUEST,types.ADM_MAIL_TEMPLATE_SUCCESS,types.ADM_MAIL_TEMPLATE_ERROR,apiMailTemplate.getAllMailTemplate)    
    }

    public [types.ADM_MAIL_TEMPLATE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_MAIL_TEMPLATE_REQUEST,context.state.mailTemplateList)    
    }

    public [types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST,types.ADM_MAIL_TEMPLATE_DETAIL_SUCCESS,types.ADM_MAIL_TEMPLATE_DETAIL_ERROR,apiMailTemplate.getMailTemplate,id)
    }

    public [types.ADM_MAIL_TEMPLATE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.mailTemplateDic[id];
        return actionEnsure(context,types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_MAIL_TEMPLATE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloMailTemplate) {
        return payloadAction(context,types.ADM_MAIL_TEMPLATE_SAVE_REQUEST,types.ADM_MAIL_TEMPLATE_SAVE_SUCCESS,types.ADM_MAIL_TEMPLATE_SAVE_ERROR,apiMailTemplate.saveMailTemplate,data)    
    }

    public [types.ADM_MAIL_TEMPLATE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_MAIL_TEMPLATE_DELETE_REQUEST,types.ADM_MAIL_TEMPLATE_DELETE_SUCCESS,types.ADM_MAIL_TEMPLATE_DELETE_ERROR,apiMailTemplate.deleteMailTemplate,id)    
    }

    public [types.ADM_MAIL_TEMPLATE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_MAIL_TEMPLATE_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////

    public [types.ADM_MAIL_SKIN_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_MAIL_SKIN_REQUEST,types.ADM_MAIL_SKIN_SUCCESS,types.ADM_MAIL_SKIN_ERROR,apiMailSkin.getAllMailSkin)    
    }

    public [types.ADM_MAIL_SKIN_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_MAIL_SKIN_REQUEST,context.state.mailSkinList)    
    }

    public [types.ADM_MAIL_SKIN_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_MAIL_SKIN_DETAIL_REQUEST,types.ADM_MAIL_SKIN_DETAIL_SUCCESS,types.ADM_MAIL_SKIN_DETAIL_ERROR,apiMailSkin.getMailSkin,id)
    }

    public [types.ADM_MAIL_SKIN_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.mailSkinDic[id];
        return actionEnsure(context,types.ADM_MAIL_SKIN_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_MAIL_SKIN_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloMailSkin) {
        return payloadAction(context,types.ADM_MAIL_SKIN_SAVE_REQUEST,types.ADM_MAIL_SKIN_SAVE_SUCCESS,types.ADM_MAIL_SKIN_SAVE_ERROR,apiMailSkin.saveMailSkin,data)    
    }

    public [types.ADM_MAIL_SKIN_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_MAIL_SKIN_DELETE_REQUEST,types.ADM_MAIL_SKIN_DELETE_SUCCESS,types.ADM_MAIL_SKIN_DELETE_ERROR,apiMailSkin.deleteMailSkin,id)    
    }

    public [types.ADM_MAIL_SKIN_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_MAIL_SKIN_RESET_STATUS)
            resolve()
        })
    }

     //////////////////////////////////////////////////////////////////
    // PAN_STATUS
    /////////////////////////////////////////////////////////////////

    public [types.ADM_PAN_STATUS_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_PAN_STATUS_REQUEST,types.ADM_PAN_STATUS_SUCCESS,types.ADM_PAN_STATUS_ERROR,apiPanStatus.getAllPanStatus)    
    }

    public [types.ADM_PAN_STATUS_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_PAN_STATUS_REQUEST,context.state.panStatusList)    
    }

    public [types.ADM_PAN_STATUS_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_PAN_STATUS_DETAIL_REQUEST,types.ADM_PAN_STATUS_DETAIL_SUCCESS,types.ADM_PAN_STATUS_DETAIL_ERROR,apiPanStatus.getPanStatus,id)
    }

    public [types.ADM_PAN_STATUS_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.panStatusDic[id];
        return actionEnsure(context,types.ADM_PAN_STATUS_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_PAN_STATUS_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloPanStatus) {
        return payloadAction(context,types.ADM_PAN_STATUS_SAVE_REQUEST,types.ADM_PAN_STATUS_SAVE_SUCCESS,types.ADM_PAN_STATUS_SAVE_ERROR,apiPanStatus.savePanStatus,data)    
    }

    public [types.ADM_PAN_STATUS_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_PAN_STATUS_DELETE_REQUEST,types.ADM_PAN_STATUS_DELETE_SUCCESS,types.ADM_PAN_STATUS_DELETE_ERROR,apiPanStatus.deletePanStatus,id)    
    }

    public [types.ADM_PAN_STATUS_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_PAN_STATUS_RESET_STATUS)
            resolve()
        })
    }

}

export default util.classToObject(AdministrationAction)
